import { client } from 'utils/http';
import { useToast } from './toast';
import { CacheKeys } from 'utils/cacheKeys';
import { useBusiness } from 'providers/context/BusinessProvider';

export const useAxiosWithToast = () => {
  const { showToast, ToastComponent } = useToast();
  const { selectedBusiness } = useBusiness();
  client.interceptors.response.use(
    (response) => {
      const successMessage = response?.data?.meta?.message;
      if (successMessage) {
        showToast(successMessage, 'success');
      }
      return response;
    },
    (error) => {
      if (error.status === 401) {
        window.location.href = '/auth/logout';
      }
      if (error.status === 404) {
        window.location.href = '/404';
      }
      const errorMessage = error.response?.data?.error || 'An unexpected error occurred';
      showToast(errorMessage, 'error');
      return Promise.reject(error);
    }
  );

  client.interceptors.request.use(
    (config) => {
      let businessIds;
      if (localStorage.getItem(CacheKeys.businessIds)) {
        businessIds = JSON.parse(localStorage.getItem(CacheKeys.businessIds) ?? '');
      }
      const selectFirstBusinessDefault = businessIds?.length > 0 ? businessIds[0] : selectedBusiness;
      config.headers['Business-Id'] = selectFirstBusinessDefault || '';
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  return { ToastComponent };
};
